export enum API_STATUS_CODES {
    CONFLICT_RESPONSE_CODE = 409,
}
